module.exports = __webpack_public_path__ + "media/content-creator/mobile-fmcg-2-c8a2b0f6.png";